
<div class="image">
    <mycampapp-image-asset *ngIf="photo && !imageRemoved && !uploadObjectUrl" [imageAsset]="photo" [width]="imageSize" [height]="imageSize" [showFullSize]="true"></mycampapp-image-asset>
    <img *ngIf="!imageRemoved && (uploadObjectUrl || photoUrl)" class="photo-preview" [src]="photoUrl ? photoUrl : uploadObjectUrl" [width]="imageSize" />
</div>

<div class="upload-area">
    <p-fileUpload accept=".jpg,.jpeg,.png" [showCancelButton]="false" [showUploadButton]="false" [customUpload]="true" [disabled]="disabled"
                  [chooseLabel]="deviceManager.isMobile ? (hasFile ? 'Replace' : 'Select') : (hasFile ? 'Replace File' : 'Select File')" (onSelect)="onFilesSelected($event)">
        <ng-template pTemplate="toolbar">
            <button *ngIf="hasFile" pButton type="button" class="p-button-warning" label="Remove" icon="pi pi-trash" [disabled]="disabled" (click)="onRemoveImage()"></button>
            <button *ngIf="allowStockImage" pButton type="button" class="stock-image-button" label="Stock Image" icon="pi pi-plus"
                    [disabled]="disabled" (click)="onChooseStockImage()"></button>
        </ng-template>
    </p-fileUpload>

    <div *ngIf="recommendedWidth" class="select-image-recommendation">
        Suggested: {{recommendedWidth}} pixels by {{recommendedHeight}} pixels
    </div>
    <div *ngIf="minWidth" class="select-image-recommendation">
        Minimum size: {{minWidth}} pixels by {{minHeight}} pixels
        <mycampapp-form-input-field-error [text]="MinimumSizeErrorMessage" severity="warn"></mycampapp-form-input-field-error>
    </div>
</div>

<mycampapp-select-stock-image *ngIf="selectStockImage" (imageSelected)="onStockImageSelected($event)"></mycampapp-select-stock-image>
